var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-wrapper"},[_c('BookItem',{staticClass:"m-5",attrs:{"quote":_vm.detailBook}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }